import { useQuery } from "@tanstack/react-query";
import { IOrgKpisApi } from "@/api/org-kpis";
import { SERVICES_TYPES, useInjection } from "@/ioc";
import { KpiPeriod } from "@/models/org-kpis";

export const useOrgsOverview = (period: KpiPeriod) => {
  const orgKpisApi = useInjection<IOrgKpisApi>(SERVICES_TYPES.ORG_KPIS);

  return useQuery({
    queryKey: ["orgs-overview", period.from, period.to],
    queryFn: () => orgKpisApi.getOverview(period)
  });
};
